import React, { useState, useEffect, useRef } from "react";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import Swal from "sweetalert2";

import {
  corePermitInitialsConst,
  BasicDetailsConstant,
  PermitIssuerConst,
  PermitReceiverConst,
  EmergencyConst,
  EqipmentInformationConst,
  ImportantConst,
  LiftConditionsConst,
  NoteConstant,
} from "../Utilities/cranePermit-JSON";
//Crane
import CorePermitInputFields from "../components/cranePermit/corePermitInputFields";
import PermitIssuer from "../components/cranePermit/PermitIssuer";
import PermitReceiver from "../components/cranePermit/PermitReceiver";
import Emergency from "../components/cranePermit/Emergency";
import BasicDetails from "../components/cranePermit/BasicDetails";
import Equipment from "../components/cranePermit/Equipment";
import Important from "../components/cranePermit/Important";
import LiftConditions from "../components/cranePermit/LiftConditions";
import Note from "../components/cranePermit/Note";
import {
  saveAdditionalPermit,
  getAllPermitsByCorePermitID,
  ApproveRejectPermit,
} from "../Utilities/URLCONSTANTS";
import {
  USER_PROFILE,
  retrieveData,
  checkForEmptyValue,
} from "../Utils";
import { useNavigate, useSearchParams } from "react-router-dom";

import Accordion from "../Accordation/Accordian";
import axios from "axios";

//Approve
import Approved from "../images/Approved.png";
import Reject from "../images/Reject.png";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import Loader_Bulk from "../Utilities/Loader_Bulk";

import "../../src/theme-colors.css";

const CranePermit2Additional = (props) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/rmloader.gif")
  );
  const [isLoading, setIsLoading] = useState(false);
  const [permitInitials, setPermitInitials] = useState(corePermitInitialsConst);
  const [permitIssuer, setPermitIssuer] = useState(PermitIssuerConst);
  const [permitReceiver, setPermitReceiver] = useState(PermitReceiverConst);
  const [emergency, setEmergency] = useState(EmergencyConst);
  const [basicDetails, setBasicDetails] = useState(BasicDetailsConstant);
  const [eqipmentInformation, setEquipmentInf] = useState(
    EqipmentInformationConst
  );
  const [important, setImportant] = useState(ImportantConst);
  const [liftConditions, setLiftConditions] = useState(LiftConditionsConst);
  const [note, setNote] = useState(NoteConstant);
  const [activeIndex, setActiveIndex] = useState(null);
  const [finalSubmit, setFinalSubmit] = useState(false);

  //Approve
  const [showApproved, setShowApproved] = useState(false);
  const [status, setStatus] = useState("");
  const [apiStatus, setApiStatus] = useState("");
  const [showModal, setShowModal] = useState(false);

  //Reject
  const [showNewModal, setShowNewModal] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [serverRecordId, setServerRecordId] = useState(null);
  const PermitUserIdfromURL = searchParams.get("acceptorUserId");
  const IdFromURL = searchParams.get("corePermitID");
  const PermitNamefromURL = searchParams.get("permitName");
  const AditionpermitIDFromURL = searchParams.get("additionalPermitID");
  const mobileNumberfromURL = searchParams.get("mb");
  const [permitStatus, setPermitStatus] = useState("");
  const [permitObject, setPermitObject] = useState(null);


  //Validations 
  const [openAccordion, setOpenAccordion] = useState(null);
  const [emergencyToggleOn, setEmergencyToggleOn] = useState(true);
  const [basicDetailsToggleOn, setBasicDetailsToggleOn] = useState(true);
  const [equipmentToggleOn, setEquipmentToggleOn] = useState(true);
  const [importantToggleOn, setImportantToggleOn] = useState(true);
  const [liftConditionsToggleOn, setLiftConditionsToggleOn] = useState(true);
  const [noteListToggleOn, setNoteListToggleOn] = useState(true);
  const [permitIssuerToggleOn, setPermitIssuerToggleOn] = useState(true);
  const [permitRecieverToggleOn, setPermitRecieverToggleOn] = useState(true);
  const [permitIntials, setPermitIntials] = useState(true);
  const [corePermitStatusState, setCorePermitStatusState] = useState("");

  useEffect(() => {
    console.log(liftConditions, "eq");
  }, [liftConditions]);
  const toggleItem = (index) => {
    // debugger;
    setActiveIndex(index === activeIndex ? null : index);
  };
  const resetForm = () => {
    setPermitIssuer(PermitIssuerConst);
    setPermitReceiver(PermitReceiverConst);
    setEmergency(EmergencyConst);
    setBasicDetails(BasicDetailsConstant);
    setEquipmentInf(EqipmentInformationConst);
    setImportant(ImportantConst);
    setLiftConditions(LiftConditionsConst);
    setNote(NoteConstant);
    // setFinalSubmit(true);
  };
  useEffect(() => {
    const search = props.location; // returns the URL query String
    const params = new URLSearchParams(search);

    var IdFromURL;
    var isEdit = "true";
    setIsEdit(isEdit);
    // alert(isEdit);
    getFormData(
      IdFromURL != undefined && IdFromURL != null && IdFromURL != ""
        ? IdFromURL
        : 0
    );
    return () => { };
  }, [isEdit]);
  async function filterArray(array, keyName, searchText) {
    console.log("responseFFFF", keyName + "---" + searchText);

    var filteredArray = [];

    for (let i = 0; i < array.length; i++) {
      if (array[i].permitID.toString() === searchText.toString()) {
        filteredArray.push(array[i]);
        break;
      }
    }
    console.log("Myfilter array::", filteredArray);
    return filteredArray[0];
  }

  const getFormData = async (id) => {
    try {
      const dataFromStore = await retrieveData(USER_PROFILE);
      const headers = await GetApiHeaders();
      const dataToSend = {
        mobileNumber: headers.mobileNumber == null ? "" : headers.mobileNumber,
        name: "",
        PermitID: IdFromURL,
      };
      setIsLoading(true);
      const response = await axios.post(
        getAllPermitsByCorePermitID,
        dataToSend
      );
      console.log("id:::", dataFromStore);
      console.log("response data:", response.data);
      // JSON.stringify(response.data.response.core_permit)
      if (response.data && response.data.response) {
        const elevated = response?.data?.response?.crane_permit || [];
        const corePermit = response?.data?.response?.core_permit?.[0] || {};
        const corePermitStatus = corePermit.permitStatus || "";
        setCorePermitStatusState(corePermitStatus);

        console.log("elevated :: ", elevated);
        // const dataLast = elevated[elevated.length - 1]?.permitObject || null;
        const dataLast =
          elevated.find(
            item => item.permitID === AditionpermitIDFromURL
          )?.permitObject || null;
        console.log("filteredArray checking", JSON.stringify(dataLast));
        if (
          response.data.response.crane_permit != null &&
          response.data.response.crane_permit.length > 0
        ) {

          setPermitStatus(
            response.data.response.crane_permit.find(
              (item) => item.permitID === AditionpermitIDFromURL
            )?.permitStatus
          );
        }
        if (dataLast) {
          setPermitObject(dataLast);
          console.log("dataLast", dataLast);
          console.log("ssn id" + response.serverRecordId);
          setPermitInitials(
            dataLast?.permitInitials ? dataLast?.permitInitials : permitInitials
          );
          setPermitIssuer(
            dataLast?.permitIssuer ? dataLast?.permitIssuer : permitIssuer
          );
          setPermitReceiver(
            dataLast?.permitReceiver ? dataLast?.permitReceiver : permitReceiver
          );
          setEmergency(dataLast?.emergency ? dataLast?.emergency : emergency);
          setBasicDetails(
            dataLast?.basicDetails ? dataLast?.basicDetails : basicDetails
          );
          setEquipmentInf(
            dataLast?.eqipmentInformation
              ? dataLast.eqipmentInformation
              : eqipmentInformation
          );
          setImportant(dataLast.important ? dataLast.important : important);
          setLiftConditions(
            dataLast.liftConditions ? dataLast.liftConditions : liftConditions
          );
          setNote(dataLast.note ? dataLast.note : note);
          //Toggle values
          setEmergencyToggleOn(dataLast.emergencyToggleOn !== undefined ? dataLast.emergencyToggleOn : emergencyToggleOn);
          setBasicDetailsToggleOn(dataLast.basicDetailsToggleOn !== undefined ? dataLast.basicDetailsToggleOn : basicDetailsToggleOn);
          setEquipmentToggleOn(dataLast.equipmentToggleOn !== undefined ? dataLast.equipmentToggleOn : equipmentToggleOn);
          setImportantToggleOn(dataLast.importantToggleOn !== undefined ? dataLast.importantToggleOn : importantToggleOn);
          setLiftConditionsToggleOn(dataLast.liftConditionsToggleOn !== undefined ? dataLast.liftConditionsToggleOn : liftConditionsToggleOn);
          setNoteListToggleOn(dataLast.noteListToggleOn !== undefined ? dataLast.noteListToggleOn : noteListToggleOn);
          setPermitIssuerToggleOn(dataLast.permitIssuerToggleOn !== undefined ? dataLast.permitIssuerToggleOn : permitIssuerToggleOn);
          setPermitRecieverToggleOn(dataLast.permitRecieverToggleOn !== undefined ? dataLast.permitRecieverToggleOn : permitRecieverToggleOn);
          setServerRecordId(elevated[elevated.length - 1]?.permitID || "0");
        }
      } else {
        console.log("Response data is missing or invalid.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  const handleAprrovedOk = async (e) => {
    e.preventDefault();
    setStatus("");
    setIsLoading(false);
    setShowApproved(false);

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("GoBack");
    }
  };

  const handleApproved = async (e) => {
    if (corePermitStatusState === "Submitted") {
      Swal.fire({
        icon: "warning",
        text: "Cannot perform this action without Core Permit approval.",
        confirmButtonColor: "#d33",
      });
      return;
    }
    const checkedNoteListyes = note.noteList.filter(
      (item) => item.cbYes === "true"
    );
    const checkedNoteListNa = note.noteList.filter(
      (item) => item.cbNA === "true"
    );

    const isNoteListCheckedyes =
      checkedNoteListyes.length >= 1
        ? "true"
        : checkedNoteListyes.length === 0 && checkedNoteListNa.length === 0
          ? ""
          : "false";

    const isNoteListCheckedNa =
      checkedNoteListNa.length >= 1
        ? "true"
        : checkedNoteListyes.length === 0 && checkedNoteListNa.length === 0
          ? ""
          : "false";
    const checkedImportantListyes = important.importantList.filter(
      (item) => item.cbYes === "true"
    );
    const checkedImportantListNa = important.importantList.filter(
      (item) => item.cbNA === "true"
    );

    const isImportantListCheckedyes =
      checkedImportantListyes.length >= 1
        ? "true"
        : checkedImportantListyes.length === 0 &&
          checkedImportantListNa.length === 0
          ? ""
          : "false";

    const isImportantListCheckedNa =
      checkedImportantListNa.length >= 1
        ? "true"
        : checkedImportantListyes.length === 0 &&
          checkedImportantListNa.length === 0
          ? ""
          : "false";
    var valuesToCheck = [];
    if (permitInitials) {
      const updatedValues = [...valuesToCheck];
      updatedValues.push({
        permitInitials: {
          initialsOne: permitInitials.initialsOne,
          initialsTwo: permitInitials.initialsTwo,
          initialsThree: permitInitials.initialsThree,
          permitsOne: permitInitials.permitsOne,
          permitsTwo: permitInitials.permitsTwo,
        },
      });
      valuesToCheck = [...updatedValues];
    }
    if (emergencyToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        emergency: {
          phoneNumber: emergency.phoneNumber,
          assemblyLocation: emergency.assemblyLocation,
        },
      };
      valuesToCheck = [...updatedValues];
    }

    if (basicDetailsToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        basicDetails: {
          company: basicDetails.company,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    if (equipmentToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        eqipmentInformation: {
          size_or_capacity_in_tons:
            eqipmentInformation.size_or_capacity_in_tons,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    if (importantToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        important: {
          importantcbyes: isImportantListCheckedyes,
          importantcbNa: isImportantListCheckedNa,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    if (liftConditionsToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        liftConditions: {
          r: liftConditions.r,
          h: liftConditions.h,
          l: liftConditions.l,
          w: liftConditions.w,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    if (noteListToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        note: {
          noteListcbyes: isNoteListCheckedyes,
          noteListcbna: isNoteListCheckedNa,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    if (permitIssuerToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        permitIssuer: {
          permitissuer: permitIssuer.permitissuer,
          permitissuerdate: permitIssuer.date,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    if (permitRecieverToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        permitReceiver: {
          permitreceiver: permitReceiver.permitreceiver,
          permitreceiverdate: permitReceiver.date,
        },
      };
      valuesToCheck = [...updatedValues];
    }
    console.log("valuesToCheck" + JSON.stringify(valuesToCheck));
    let allCasesValid = true;
    for (const item of valuesToCheck) {
      const returnKey = checkForEmptyValue(item);
      switch (returnKey) {
        case "permitInitials":
          const { initialsOne, initialsTwo, initialsThree, permitsOne, permitsTwo } = permitInitials;
          if (!initialsOne || !initialsTwo || !initialsThree || !permitsOne || !permitsTwo) {
            Swal.fire({
              icon: "warning",
              text: "Please Enter All Initials & Permits",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
            return;
          }
          break;
      }
    }

    if (e == "Submitted") {
      console.log(e, "handleOk");
      if (allCasesValid) {
        const userProfileData = {
          id: AditionpermitIDFromURL ? AditionpermitIDFromURL : "0",
          mobileNumber: mobileNumberfromURL,
          name: "",
          corePermitID: IdFromURL ? IdFromURL : 0,
          additionalPermitName: "crane_permit",
        };
        const finalJson = {
          request: {
            permitInitials,
            emergency,
            basicDetails,
            eqipmentInformation,
            important,
            liftConditions,
            note,
            permitIssuer,
            permitReceiver,
            emergencyToggleOn,
            basicDetailsToggleOn,
            equipmentToggleOn,
            importantToggleOn,
            liftConditionsToggleOn,
            noteListToggleOn,
            permitIssuerToggleOn,
            permitRecieverToggleOn,
          },
          ...userProfileData,
        };
        console.log(finalJson, "finalJson***");
        setIsLoading(true);
        const response1 = await axios.post(saveAdditionalPermit, finalJson);
        setIsLoading(false);
        if (response1.data.statusCode == 200) {
          const ApproveData = {
            acceptorUserId: PermitUserIdfromURL,
            permitName: PermitNamefromURL,
            corePermitID: IdFromURL,
            additionalPermitID: AditionpermitIDFromURL,
            status: "Approve",
            deviceType: "iOS, Android",
            remarks: "",
          };
          setIsLoading(true);
          const response = await axios.post(ApproveRejectPermit, ApproveData);
          console.log("responce", response);
          setTimeout(() => {
            setIsLoading(false);
            setApiStatus(response.data.message);
            setShowApproved(true);
          }, 3000);
        }
      }
    } else if (e == "Approve") {
      if (allCasesValid) {
        handleSubmit();
      }
    }
  };
  const handleBackButtonClick = () => {
    // Handle navigation logic here
    navigate(-1);
  };


  const handleReject = (e) => {
    e.preventDefault();
    // Check if Core Permit Status is "Submitted"
    if (corePermitStatusState === "Submitted") {
      Swal.fire({
        icon: "warning",
        text: "Cannot perform this action without Core Permit approval.",
        confirmButtonColor: "#d33",
      });
      return;
    }
    const { initialsOne, initialsTwo, initialsThree, permitsOne, permitsTwo } = permitInitials;
    if (!initialsOne || !initialsTwo || !initialsThree || !permitsOne || !permitsTwo) {
      Swal.fire({
        icon: "warning",
        text: "Please Enter All Initials & Permits",
        confirmButtonColor: "#d33",
      });
      return;
    }
    setShowReject(true);
    setRemarks("");
    setIsLoading(false);
  };

  const handleConfirmationOk = () => {
    setShowReject(false);
    setShowConfirmationPopup(false);
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("GoBack");
    }
  };

  const handleNewModalOk = () => {
    setShowNewModal(false);
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("GoBack");
    }
  };

  const handleCancelReject = () => {
    setShowReject(false);
  }



  const handleRejectOk = async (e) => {
    try {
      e.preventDefault();
      if (!remarks.trim()) {
        Swal.fire({
          icon: "warning",
          text: "Please Enter Remarks Before Proceeding.",
          confirmButtonColor: "#d33",
        });
        return;
      }
      const userProfileData = {
        id: AditionpermitIDFromURL ? AditionpermitIDFromURL : "0",
        mobileNumber: mobileNumberfromURL,
        name: "",
        corePermitID: IdFromURL ? IdFromURL : 0,
        additionalPermitName: "crane_permit",
      };

      const finalJson = {
        request: {
          permitInitials,
          emergency,
          basicDetails,
          eqipmentInformation,
          important,
          liftConditions,
          note,
          permitIssuer,
          permitReceiver,
          emergencyToggleOn,
          basicDetailsToggleOn,
          equipmentToggleOn,
          importantToggleOn,
          liftConditionsToggleOn,
          noteListToggleOn,
          permitIssuerToggleOn,
          permitRecieverToggleOn,
        },
        ...userProfileData,
      };

      setIsLoading(true);
      try {
        // Save the CorePermit data
        const response = await axios.post(saveAdditionalPermit, finalJson);
        console.log("Crane permit response:", response);

        if (response.data.statusCode === "200") {
          const RejectData = {
            acceptorUserId: PermitUserIdfromURL,
            permitName: PermitNamefromURL,
            corePermitID: IdFromURL,
            additionalPermitID: AditionpermitIDFromURL || "0",
            status: "Reject",
            deviceType: "iOS, Android",
            remarks: remarks,
          };

          // Send rejection data
          const rejectResponse = await axios.post(ApproveRejectPermit, RejectData);
          console.log("Rejection response:", rejectResponse);

          if (rejectResponse.data.statusCode !== "200") {
            setShowConfirmationPopup(true);
            setApiStatus(rejectResponse.data.message);
          } else {
            setShowConfirmationPopup(true);
            setApiStatus("Rejection successful!");
          }
        }
      } catch (err) {
        console.error("Error in submission:", err);
      } finally {
        setIsLoading(false);
        setShowReject(false);
      }
    } catch (error) {
      console.error("Error in handleRejectOk:", error);
    }
  };



  const handleToggleItems = () => {
    setEmergencyToggleOn(!emergencyToggleOn)
  }

  const handleBasicDetailsItems = () => {
    setBasicDetailsToggleOn(!basicDetailsToggleOn)
  }

  const handleEquipmentItems = () => {
    setEquipmentToggleOn(!equipmentToggleOn)
  }
  const handleImportantToggleOnItems = () => {
    setImportantToggleOn(!importantToggleOn)
  }

  const handleLiftConditionsToggleOnItems = () => {
    setLiftConditionsToggleOn(!liftConditionsToggleOn)
  }

  const handleIsNoteListToggleOnItems = () => {
    setNoteListToggleOn(!noteListToggleOn)
  }

  const handlePermitIssuerToggleOnItems = () => {
    setPermitIssuerToggleOn(!permitIssuerToggleOn)
  }

  const handlePermitReceiverToggleOnItems = () => {
    setPermitRecieverToggleOn(!permitRecieverToggleOn)
  }


  const handleSubmit = async () => {
    // event.preventDefault();
    const userProfileData = {
      id: AditionpermitIDFromURL ? AditionpermitIDFromURL : "0", //serverRecordId ? serverRecordId : "0",
      mobileNumber: mobileNumberfromURL,
      name: "",
      corePermitID: IdFromURL ? IdFromURL : 0,
      additionalPermitName: "crane_permit",
    };
    const finalJson = {
      request: {
        permitInitials,
        emergency,
        basicDetails,
        eqipmentInformation,
        important,
        liftConditions,
        note,
        permitIssuer,
        permitReceiver,
        emergencyToggleOn,
        basicDetailsToggleOn,
        equipmentToggleOn,
        importantToggleOn,
        liftConditionsToggleOn,
        noteListToggleOn,
        permitIssuerToggleOn,
        permitRecieverToggleOn,
      },
      ...userProfileData,
    };
    console.log(finalJson, "finalJson***");
    setIsLoading(true);
    const response = await axios.post(saveAdditionalPermit, finalJson);
    console.log(response.status, "sdmnhba");
    console.log("response", response);
    setIsLoading(false);
    if (response.data.statusCode == 200) {
      setApiStatus(response.data.message);
      setShowApproved(true);
    }
  };

  return (
    <body id="page-top">
      <div id="wrapper">
        {/* 
                <SideMenu /> */}
        <div
          id="content-wrapper"
          className="d-flex flex-column"
          style={{ backgroundColor: "white" }}
        >
          {finalSubmit ? (
            <>
              <h2>Form Submitted Successfully!!!</h2>
            </>
          ) : (
            <div id="content">
              {/* 
                        <Header /> */}
              <div
                className="row"
                style={{ backgroundColor: "var(--theme-bg-primary-color)", padding: "7px" }}
              >
                <div className="col-md-3 col-12"></div>
              </div>
              <div>
                <div className="container-fluid">
                  <div className="d-flex justify-content-between"></div>
                  <div>
                    <form className="crane_permit-form">
                      <style>{`
                        .crane_permit-form .form-check {
                          padding-left: 1.5rem !important;
                        }
                      `}</style>
                      <CorePermitInputFields
                        data={permitInitials}
                        setPermitInitials={setPermitInitials}
                        editable={true}
                        onDataChange={(data) => {
                          setPermitInitials(data);
                        }}
                      />
                      <Accordion
                        title="EMERGENCY"
                        bgColor="#DF3A1C"
                        handleToggle={handleToggleItems}
                        isToggled={emergencyToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="emergency"
                        content={
                          <Emergency
                            data={emergency}
                            emergencyToggleOn={emergencyToggleOn}
                            setEmergency={setEmergency}
                            onDataChange={(data) => {
                              setEmergency(data);
                            }}
                          />
                        }
                        bordercolor="#DF3A1C"
                        showToggle={true}
                      />
                      <Accordion
                        title="BASIC DETAILS"
                        bgColor="#2C53A5"
                        handleToggle={handleBasicDetailsItems}
                        isToggled={basicDetailsToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="basicDetails"
                        content={
                          <BasicDetails
                            data={basicDetails}
                            basicDetailsToggleOn={basicDetailsToggleOn}
                            setBasicDetails={setBasicDetails}
                            onDataChange={(data) => {
                              setBasicDetails(data);
                            }}
                          />
                        }
                        bordercolor="#2C53A5"
                        showToggle={true}
                      />
                      <Accordion
                        title="EQUIPMENT INFORMATION"
                        bgColor="#F58355"
                        handleToggle={handleEquipmentItems}
                        isToggled={equipmentToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="equipmentInformation"
                        content={
                          <Equipment
                            data={eqipmentInformation}
                            equipmentToggleOn={equipmentToggleOn}
                            setEquipmentInf={setEquipmentInf}
                            onDataChange={(data) => {
                              setEquipmentInf(data);
                            }}
                          />
                        }
                        bordercolor="#F58355"
                        showToggle={true}
                      />
                      <Accordion
                        title="IMPORTANT"
                        bgColor="#2C53A5"
                        handleToggle={handleImportantToggleOnItems}
                        isToggled={importantToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="important"
                        content={
                          <Important
                            data={important}
                            importantToggleOn={importantToggleOn}
                            setImportant={setImportant}
                            onDataChange={(data) => {
                              setImportant(data);
                            }}
                          />
                        }
                        bordercolor="#2C53A5"
                        showToggle={true}
                      />
                      <Accordion
                        title="LIFT CONDITIONS"
                        bgColor="#5F92CD"
                        handleToggle={handleLiftConditionsToggleOnItems}
                        isToggled={liftConditionsToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="liftConditions"
                        content={
                          <LiftConditions
                            data={liftConditions}
                            liftConditionsToggleOn={liftConditionsToggleOn}
                            setLiftConditions={setLiftConditions}
                            onDataChange={(data) => {
                              setLiftConditions(data);
                            }}
                          />
                        }
                        bordercolor="#5F92CD"
                        showToggle={true}
                      />
                      <Accordion
                        title="NOTE"
                        bgColor="#2B2B2B"
                        handleToggle={handleIsNoteListToggleOnItems}
                        isToggled={noteListToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="note"
                        content={
                          <Note
                            data={note}
                            noteListToggleOn={noteListToggleOn}
                            setNote={setNote}
                            onDataChange={(data) => {
                              setNote(data);
                            }}
                          />
                        }
                        bordercolor="#2B2B2B"
                        showToggle={true}
                      />
                      <Accordion
                        title="Permit Issuer"
                        bgColor="#CB3A27"
                        handleToggle={handlePermitIssuerToggleOnItems}
                        isToggled={permitIssuerToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="permitIssuer"
                        content={
                          <PermitIssuer
                            data={permitIssuer}
                            permitIssuerToggleOn={permitIssuerToggleOn}
                            setPermitIssuer={setPermitIssuer}
                            onDataChange={(data) => {
                              setPermitIssuer(data);
                            }}
                          />
                        }
                        bordercolor="#CB3A27"
                        showToggle={true}
                      />
                      <Accordion
                        title="Permit Receiver"
                        bgColor="#CB3A27"
                        handleToggle={handlePermitReceiverToggleOnItems}
                        isToggled={permitRecieverToggleOn}
                        openAccordion={openAccordion}
                        setOpenAccordion={setOpenAccordion}
                        index="permitReceiver"
                        content={
                          <PermitReceiver
                            data={permitReceiver}
                            permitRecieverToggleOn={permitRecieverToggleOn}
                            setPermitReceiver={setPermitReceiver}
                            onDataChange={(data) => {
                              setPermitReceiver(data);
                            }}
                          />
                        }
                        bordercolor="#CB3A27"
                        showToggle={true}
                      />

                      <div style={{ marginTop: "20px" }}>
                        {permitStatus !== "" && (
                          <button
                            type="button"
                            onClick={() => {
                              handleApproved(permitStatus);
                            }}
                            className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white  ${"custom-rounded"}`}
                            style={{
                              height: "50px",
                              // backgroundColor: "#007AFF",
                              backgroundColor: "var(--theme-bg-primary-color)",
                              color: "white",
                              border: "none",
                              marginTop: "10px",
                            }}
                          >
                            {permitStatus == "Submitted" ? "Approve" : "Update"}
                          </button>
                        )}
                        {permitStatus == "Submitted" && (
                          <button
                            type="button"
                            onClick={handleReject}
                            className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white  ${"custom-rounded"}`}
                            style={{
                              height: "50px",
                              backgroundColor: "#FC2727",
                              color: "white",
                              border: "none",
                              marginTop: "10px",
                            }}
                          >
                            Reject
                          </button>
                        )}
                      </div>
                      <div>
                        <Modal
                          show={showApproved}
                          onHide={() => setShowApproved(false)}
                          size="sm"
                          id="nsmodel"
                          className="ppopup"
                        >
                          <Modal.Body>
                            <div>
                              <div className="row">
                                <div>
                                  <span
                                    style={{
                                      textAlign: "center",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "15vh",
                                    }}
                                  >
                                    <img
                                      src={Approved}
                                      alt="save"
                                      className="popupicons"
                                    />
                                  </span>
                                </div>
                              </div>
                              <div>
                                <p
                                  style={{
                                    textAlign: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "3vh",
                                  }}
                                >
                                  <h5>{apiStatus}</h5>
                                  {/* Crane Permit approved successfully */}
                                </p>
                              </div>
                              <div>
                                <p
                                  style={{
                                    textAlign: "center",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "0px",
                                  }}
                                >
                                  <Button
                                    variant="primary"
                                    className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white mb-2  ${"custom-rounded"}`}
                                    style={{
                                      height: "43px",
                                      // backgroundColor: "#007AFF",
                                      backgroundColor: "var(--theme-bg-primary-color)",
                                      color: "white",
                                      border: "none",
                                    }}
                                    onClick={handleAprrovedOk}
                                  >
                                    Ok
                                  </Button>
                                </p>
                              </div>
                            </div>
                          </Modal.Body>

                        </Modal>
                      </div>

                      <div>
                        <Modal
                          show={showReject}
                          onHide={() => setShowReject(false)}
                          size="sm"
                          id="nsmodel"
                          className="ppopup"
                        >
                          <Modal.Header className="no-border">
                            <Button
                              variant="link"
                              className="close btn btn-danger close_btn"
                              onClick={handleCancelReject}
                            >
                              X
                            </Button>
                          </Modal.Header>


                          <Modal.Body>
                            <div>
                              <div className="row">
                                <div>
                                  <span
                                    style={{
                                      textAlign: "center",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "15vh",
                                    }}
                                  >
                                    <img
                                      src={Reject}
                                      alt="save"
                                      className="popupicons"
                                    />
                                  </span>
                                </div>
                              </div>
                              <div>
                                <p
                                  style={{
                                    textAlign: "center",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "3vh",
                                  }}
                                >
                                  <h5>Are you sure want to Reject?</h5>
                                </p>
                              </div>

                            </div>

                            <div className="form-group">
                              <label htmlFor="name">
                                <h6>Reason:</h6>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Reason for Rejection"
                                value={remarks}
                                onChange={(e) => {
                                  setRemarks(e.target.value);
                                }}
                              />
                            </div>

                            <div>
                              <p
                                style={{
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "8vh",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white mb-2  ${"custom-rounded"}`}
                                  style={{
                                    height: "43px",
                                    // backgroundColor: "#007AFF",
                                    backgroundColor: "var(--theme-bg-primary-color)",
                                    color: "white",
                                    border: "none",
                                  }}
                                  onClick={handleRejectOk}
                                  disabled={remarks.trim() === ""}
                                >
                                  Ok
                                </Button>
                              </p>
                            </div>

                            <Modal
                              show={showNewModal}
                              onHide={() => setShowNewModal(false)}
                              size="sm"
                              id="newModal"
                              className="ppopup"
                            >
                              <Modal.Body>
                                <div className="row">
                                  <div>
                                    <span
                                      style={{
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "15vh",
                                      }}
                                    >
                                      <img
                                        src={Approved}
                                        alt="save"
                                        className="popupicons"
                                      />
                                    </span>
                                  </div>
                                  <div>
                                    <p
                                      style={{
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "3vh",
                                      }}
                                    >
                                      <h5>CranePermit Rejected Successfully</h5>
                                    </p>
                                  </div>
                                </div>
                                <Button
                                  variant="primary"
                                  onClick={handleNewModalOk}
                                >
                                  Ok
                                </Button>
                              </Modal.Body>
                            </Modal>
                          </Modal.Body>

                        </Modal>

                        {/* Confirmation Popup */}
                        <Modal
                          show={showConfirmationPopup}
                          onHide={() => setShowConfirmationPopup(false)}
                          size="sm"
                          id="nsmodel"
                          className="ppopup"
                        >
                          <Modal.Body>
                            <div className="row">
                              <span
                                style={{
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "13vh",
                                }}
                              >
                                <img
                                  src={Reject}
                                  alt="save"
                                  className="popupicons"
                                />
                              </span>
                            </div>

                            <div className="form-group">
                              <p
                                style={{
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "3vh",
                                  color: "#4A7729",
                                }}
                              >
                                <h5>CranePermit Rejected Successfully</h5>
                              </p>
                            </div>
                            <div
                              className="d-flex"
                              style={{
                                width: "100%",
                                justifyContent: "center",
                              }}
                            >
                              <Button
                                variant="primary"
                                className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white mb-2  ${"custom-rounded"}`}
                                style={{
                                  height: "43px",
                                  // backgroundColor: "#007AFF",
                                  backgroundColor: "var(--theme-bg-primary-color)",
                                  color: "white",
                                  border: "none",
                                }}
                                onClick={handleConfirmationOk}
                              >
                                Ok
                              </Button>
                            </div>

                          </Modal.Body>
                        </Modal>
                      </div>
                    </form>

                  </div>
                </div>
                {/*  Clseout end */}
              </div>
              {/* <Footer /> */}
              {/* ... End of Footer...  */}
            </div>
          )}
        </div>
        {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </div>
      {isLoading && (
        <Loader_Bulk
          loading={isLoading}
          // message={"Fetching Data. Please Wait..!"}
          message={"Processing your request. This may take a moment..!"}
          loderimage={loaderImage}
        />
      )}
    </body>
  );
};

export default CranePermit2Additional;
